import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useHistory } from "react-router";
import {
  Box,
  Card,
  CardHeader,
  Grid,
  IconButton,
  Typography,
  Badge,
  Checkbox,
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import {
  CancelRounded,
  EditRounded,
  ShoppingCart,
} from "@material-ui/icons";
import { useStepper } from "../Stepper/hooks";
import { Stepper } from "../Stepper/Stepper";
import { Step } from "../Stepper/Step";
import { StepperControlFooter } from "../Stepper/StepperControlFooter";
import PermitContent from "./PermitContent";
import Text from "../Text/Text";
import PermitAddedModel from "../Modals/buyCitation/permitAddedModel";
import BuyPerimtsEditOrderModal from "../Modals/buypermits/BuyPermitsExitOrderModal";
import {
  editBuyPermitSelectedPermit,
  hideBuyPermitThankYouModal,
  hideBuyPermitsExitOrderModal,
  setBuyPermitSelectedPermit,
  showAllowedVehicleAlertModal,
  showBuyPermitsExitOrderModal,
  updateBuyPermitVehicleList,
} from "../../store/buyPermits/action";
import { RouteService } from "../../services/route.service";
import { getCustomer } from "../../store/home/selector";
import { getUserContextData } from "../../store/login/selector";
import {
  showAllBuyPermitList,
  showBuyTermAndCondition,
} from "../../store/login/action";
import BuyTermAndCondition from "../Modals/buypermits/BuypermitTermsCondition";
import AllBuyPermitList from "../Modals/buypermits/AllBuyPermitList";
import { getProfileData } from "../../store/profile/selector";
import { setAddPermitSelectdate } from "../../store/addPermitText/action";
import AllowedVehicleAlertModal from "../Modals/buypermits/AllowedVehicleAlertModal";
import AlertModal from "../Modals/buypermits/AlertModal";
import {
  getCheckboxAgreementTextEditorDataAction,
  getOrderCompletePageEditorDataAction,
  getPaymentPageEditorDataAction,
  getReviewAndOrderEditorDataAction,
} from "../../store/profile/action";
import { getDashboardHtmlWithSession } from "../../store/dashboard/action";
import { driverPermitResion, driverSelectedGridPermit } from "../../store/permitList/selector";
import { getNewPermitOrderDataAction } from "../../store/profile/action";
import SameVehicleAlertModal from "../Modals/buypermits/SameVehicleAlertModal";
import DenyPermitRuleModal from "../Modals/buypermits/DenyPermitRuleModal";

import "./page.css";

const useStyles = makeStyles((theme) => ({
  p5: {
    padding: "5px",
    alignItems: "center",
    textAlign: "center",
  },
  p5permit: {
    padding: "7px",
    border: "1px solid gray",
    alignItems: "center",
    textAlign: "center",
    margin: "5px 0px 5px 5px",
  },

  rightGrid: {
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    right: "10%",
  },
  toolbarContainer: {
    marginBottom: "10px",
    position: "relative",
    padding: "10px",
  },
  rightIconsContainer: {
    position: "absolute",
    right: "20px",
    top: 0,
  },
  headinText: {
    color: theme.palette.primary.main,
    fontWeight: "600",
  },
  handleNextterms: {
    color: theme.palette.primary.main,
  },
  dflex: {
    display: "flex",
  },
  dflex1: {
    display: "flex",
    fontSize: "14px",
    LineHeight: "25px",
  },
  dflexpermit: {
    display: "flex",
    padding: 10,
    backgroundColor: "white",
    alignItems: "center",
  },
  dflexpermitright: {
    marginLeft: "5px",
  },
  secondContainer: {
    textAlign: "center",
  },

  availablevehiclescolor: {
    color: theme.palette.primary.main,
  },
  availablevehiclesHeading: {
    color: theme.palette.primary.main,
    marginLeft: "15px",
  },
  active: {
    background: "#e5e5e5",
  },
  thirdStepFirstDiv: {
    borderRadius: "5px",
    boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.75)",
    width: "auto",
    marginRight: "10px",
  },
  vehicleCardHeader: {
    background: "#20419a",
    color: "white",
    padding: "5px 15px",
  },
  vehiclesUl: {
    listStyleType: "none",
    padding: 10,
    margin: 0,
    LineHeight: "25px",
    fontSize: "11px",
  },
  thirdStepFirstDivChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    color: "white",
  },
  stepperPadding: {
    padding: "24px",
  },
  checkboxcolor: {
    color: theme.palette.primary.main,
  },
  firstStepFirstChildMaindiv: {
    padding: "6px",
    width: "auto",
    color: "white",
    marginRight: "15px",
    height: "fit-content",
    border: "1px solid gray",
    borderRadius: 10,
    textAlign: "center",
  },
  firstStepFirstChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    width: "auto",
    color: "white",
    borderRadius: "2px",
  },
  mt18: {
    // marginTop: "-18px",
  },
  dflexterm: {
    display: "flex",
  },
  backgroundtheme: {
    color: theme.palette.primary.main,
  },
}));

export default function AddPermitPage(props) {
  const classes = useStyles();
  const { allPermit, handletoggleAddPermitPage, StylingItem, selectedDate, setSelectedDate } = props;
  const [stepper, next, back, handleBack] = useStepper({ steps: 3 });
  const { clientName } = useSelector(getProfileData);
  const [toggleAddedModel, settoggleAddedModel] = useState(false);
  const [selectedVehicles, setSelectedVehicle] = useState();
  const [selectedVehicleLimit, setSelectedVehicleLimit] = useState();
  const [orderList, setorderList] = useState([]);
  const [permitList, setPermitList] = useState([]);
  const [permit, setPermit] = useState([]);
  const [PhysicalPermit, setPhysicalPermit] = useState([]);
  const profileStore = useSelector(getProfileData);
  const [permitType, setPermitType] = useState("");
  const [VirtualPermit, setVirtualPermit] = useState([]);
  const [PurchageList, setPurchageList] = useState();
  const [resionText, setResionText] = useState("");
  const [openDenyPermit, setOpenDenyPermit] = useState(false)

  const profileUpdateData = useSelector(
    (state) =>
      state?.profileState?.profileStateList?.endUserAccountEntity?.person
  );

  const allPermitError = useSelector(
    (state) => state.driverPermitListReducer.driverPermitListStateListError
  );

  const getPaymentMethodState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitPaymentMethods
  );

  const editPermitId = useSelector(
    (state) => state?.exitOrderReducer?.buyPemitEditVehicle
  );
  const selectedRegisteredVehicles = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitRegisteredVehicleList
  );
  const driverViewOrderStateList = useSelector(
    (state) => state.driverViewOrderReducer.driverViewOrderStateList
  );

  const getBuyPermitSelectedPermitsState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitSelectedPermits
  );
  const [selectedPerimtData, setSelectedPermitData] = useState(
    getBuyPermitSelectedPermitsState
  );
  const selectedpermitgrid = useSelector(driverSelectedGridPermit);
  const virtualpermitReason = useSelector(driverPermitResion);

  useEffect(() => {
    setSelectedPermitData(getBuyPermitSelectedPermitsState);
  }, [getBuyPermitSelectedPermitsState]);

  const [vehicleList, setvehicleList] = useState([]);
  const [threeArrays, setThreeArrays] = useState([]);
  const [isDisableSubmit, setIsDisableSubmit] = useState(true);
  const [selectedPermit, setSelectedPermit] = useState([]);
  const [d, setD] = useState([]);
  const [defaultChecked, setDefaultChecked] = useState(false);
  const [check, setCheck] = useState(false);
  const [vehicles, setvehicles] = useState([]);
  const [noOfAllowedPermit, setNoOfAllowedPermit] = useState();
  const [isOpenAllowedVehicleAlertModal, setIsOpenAllowedVehicleAlertModal] = useState(false);
  const [isOpenAllowedSameVehicleAlertModal, setIsOpenAllowedSameVehicleAlertModal] = useState(false);
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false);
  const [msg, setmsg] = useState("");
  const [permitId, setPermitId] = useState();
  const customerName = useSelector(getCustomer);
  const [count, setCount] = useState(1);
  const [testDate, setTestDate] = useState();
  const [defaultsameVehicle, setDefaultsameVehicle] = useState(false);

  useEffect(() => {
    setSelectedPermit(
      (Array.isArray(permitList) &&
        permitList?.find((e) => e?.id === editPermitId?.permit_id)) ||
      (Array.isArray(PhysicalPermit) &&
        VirtualPermit?.find((e) => e?.id === editPermitId?.permit_id)) ||
      (Array.isArray(VirtualPermit) &&
        VirtualPermit?.find((e) => e?.id === editPermitId?.permit_id))
    );
  }, [editPermitId, permitList]);

  const CloseAlertModal = () => {
    setIsOpenAlertModal(false);
  };

  // let allPermit = useSelector(
  //   (state) => state.driverPermitListReducer.driverPermitListStateList
  // );

  var allowedNoOfPermit = Array.isArray(getPaymentMethodState) && getPaymentMethodState?.filter((itm) => {
    return itm.ruleValues
  })

  const validEndDate = (endDate, validDate) => {
    var isafter = moment(testDate).add(validDate, 'days').isAfter(endDate);
    if (!testDate) {
      return moment(endDate)?.format("MM/DD/YYYY")
    } else if (isafter === false) {
      return moment(testDate).add(validDate, 'days')?.format("MM/DD/YYYY")
    } else {
      return moment(endDate)?.format("MM/DD/YYYY")
    }
  }

  useEffect(() => {
    var allowedpmt =
      Array.isArray(getPaymentMethodState) &&
      getPaymentMethodState?.filter((itm) => {
        if (itm.ruleType === "MAX_NUMBER_PERMIT_SALES") {
          return itm;
        }
      });
    if (
      profileStore &&
      profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0
    ) {
    } else {
      setNoOfAllowedPermit(allowedpmt[1]?.ruleValues || ["ONLINE_CC"]);
    }
  }, [getPaymentMethodState]);

  var status = Array.isArray(driverStatus) && driverStatus[0]?.value;

  function isDateGrater(date1, date2) {
    if (date1.getFullYear() > date2.getFullYear()) {
      return true;
    } else if (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() > date2.getMonth()
    ) {
      return true;
    } else if (
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() >= date2.getDate()
    ) {
      return true;
    }
    return false;
  }

  var PerchasedPermitList =
    Array.isArray(orderList) &&
    orderList?.filter((pmtOrder, i) => {
      let date1 = pmtOrder?.lines[0]?.item?.validEndDate;
      let orderDate = new Date(date1);
      let date2 = new Date();
      if (isDateGrater(orderDate, date2)) {
        return pmtOrder?.lines[0]?.item;
      }
    });

  var purchasedPermitListName = PerchasedPermitList?.map((elmt, ndx) => {

    return elmt?.lines;
  });

  var filteredPerchasedList = purchasedPermitListName?.map((prmt) => {
    // return prmt[0]?.item.id;
  });

  var driverStatus =
    profileStore &&
    profileStore?.endUserAccountEntity?.driverAttributes?.filter(
      (item, index) => {
        if (item?.name == "Status") {
          return item;
        }
      }
    );

  useEffect(() => {
    const filteredPermit = permit?.filter((item, i) => {
      if (filteredPerchasedList?.indexOf(item?.id) == -1) {
        return item;
      }
    });

    if (
      profileStore &&
      profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0
    ) {
    } else {
      setPermitList(filteredPermit);
    }
  }, [permit, profileStore, getPaymentMethodState]);

  const permitsForGrid = useMemo(() => {
    const filteredPermit = permit?.filter((item, i) => {
      if (filteredPerchasedList?.indexOf(item?.id) == -1) {
        return item;
      }
    });

    if (
      status === "undefined" ||
      (profileStore &&
        profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0)
    ) {
      // alert('there are no any attribute')
      return [];
    } else {
      return filteredPermit;
    }
  }, [permitList, profileStore, orderList, getPaymentMethodState]);

  //########################### Physical pmt start ########################
  const PhysicalpermitsForGrid = useMemo(() => {
    const filteredPermit2 =
      Array.isArray(PhysicalPermit) &&
      PhysicalPermit?.filter((item, i) => {
        // if (filteredPerchasedList?.indexOf(item?.id) == -1) {
        //   return item;
        // }
        return item;
      });

    if (
      status === "undefined" ||
      (profileStore &&
        profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0)
    ) {
      // alert('there are no any attribute')
      return [];
    } else {
      return filteredPermit2;
    }
  }, [permitList, profileStore, getPaymentMethodState, orderList]);

  //########################### Physical pmt end ##########################
  const dispatch = useDispatch();
  useEffect(() => {
    setSelectedVehicle(selectedRegisteredVehicles);
  }, [selectedRegisteredVehicles]);

  useEffect(() => {
    dispatch(hideBuyPermitThankYouModal());
    setorderList(driverViewOrderStateList);
  }, [driverViewOrderStateList, dispatch]);

  const user = useSelector(getUserContextData);
  const group = useSelector(getCustomer);

  /** get profile data from reducer  */

  const getBuyPermitsExitOrderModal = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitsExitOrderModal
  );

  const addpermittext = useSelector(
    (state) => state?.profileState?.newOrderPermitPageEditorData
  );

  const [isOpenExitOrderModal, setExitOrderModal] = useState(
    getBuyPermitsExitOrderModal
  );

  const history = useHistory();

  useEffect(() => {
    setExitOrderModal(getBuyPermitsExitOrderModal);
  }, [getBuyPermitsExitOrderModal]);
  useEffect(() => {
    dispatch(getNewPermitOrderDataAction({ groupName: user?.user?.userGroup || profileStore?.permission}));
  }, [user]);

  const location = {
    pathname: RouteService.home(group) + "/dashboard",
  };

  const allowedVehicleModalState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitAllowedVehicleAlertState
  );
  const EndUserId = useSelector(
    (state) => state?.profileState?.profileStateList?.endUserAccountEntity?.id
  );


  useEffect(() => {
    setIsOpenAllowedVehicleAlertModal(allowedVehicleModalState);
  }, [allowedVehicleModalState, EndUserId]);


  useEffect(() => {
    setTimeout(() => {
      if (count == 1) {
        if (allPermitError && allPermitError[0] === "You are unable to purchase permits, you have pending unpaid citations on your records.") {
          setOpenDenyPermit(true);
        }
      }
      setCount(0);
    }, 2000)

    validEndDate();
  }, [allPermit, allPermitError])


  const handleSubmit = () => {
    //handletoggleAddPermitPage();
    setSelectedDate(testDate);
    dispatch(setAddPermitSelectdate(selectedDate))
    handleToggleAddedModel();
    if (editPermitId.permit_id != "" || 0) {
      dispatch(
        editBuyPermitSelectedPermit({
          permit: selectedPermit,
          vehicles: vehicles,
          editPermitId: editPermitId,
        })
      );
    } else {
      dispatch(
        setBuyPermitSelectedPermit({
          permit: { ...d, tdate: testDate },
          vehicles: vehicles,
          reasonForVisit: resionText
        })
      );
    }
    dispatch(updateBuyPermitVehicleList([]));
  };

  const handleAllowedVehicleAlertModal = (allwedNoVehicles) => {
    dispatch(showAllowedVehicleAlertModal(allwedNoVehicles));
  };

  const handleSelectvehicle = (e, plate, sad) => {
    //start Add same vehcle

    if (selectedPermit?.id) {

      for (let i = 0; i < getBuyPermitSelectedPermitsState?.length; i++) {
        if (getBuyPermitSelectedPermitsState[i]?.permit?.id == selectedPermit?.id || getBuyPermitSelectedPermitsState?.length <= 1) {
          if (selectedPermit?.name === getBuyPermitSelectedPermitsState[i]?.permit?.name || getBuyPermitSelectedPermitsState?.length <= 1) {
            setIsOpenAllowedSameVehicleAlertModal(true)
          } else {
            if (sad.id) {
              let getPermitLength = getBuyPermitSelectedPermitsState.length
              for (let pmtLimit = 0; pmtLimit < getPermitLength; pmtLimit++) {
                let subVehicleLimit = getBuyPermitSelectedPermitsState[pmtLimit]?.vehicles
                for (let vhsub = 0; vhsub < subVehicleLimit?.length; vhsub++) {
                  if (sad.id == subVehicleLimit[vhsub]?.id) {
                    setIsOpenAllowedSameVehicleAlertModal(true)
                    setDefaultsameVehicle(true)
                    e.target.checked = false;
                  }
                }
              }
            }
          }

        }
      }
    }

    //End

    if (vehicles && vehicles?.length >= 2) {
      e.stopPropagation();
    }

    let tmpPermit = [...vehicles];
    let index =
      vehicles && vehicles?.findIndex((e) => e.licensePlate.number === plate);
    if (index !== -1) {
      tmpPermit.splice(index, 1);
    } else {
      if (selectedVehicles?.length < selectedPermit?.allowedNoVehicles) {
        tmpPermit.push(
          vehicleList.vehicles.find((e) => e.licensePlate.number === plate)
        );
      } else {
        // setSelectedVehicleLimit(selectedPermit)
        e.target.checked = false;
        handleAllowedVehicleAlertModal(selectedPermit?.allowedNoVehicles);
      }
    }
    setvehicles(tmpPermit);
    dispatch(updateBuyPermitVehicleList(tmpPermit));
  };

  const handleNext = () => {
    next(stepper.current);
  };

  const handleJump = (number) => {
    handleBack(number);
  };

  const handleToggleAddedModel = () => {
    settoggleAddedModel(!toggleAddedModel);
    handleBack(0);
  };

  const stylingVal = {
    backgroundColor: StylingItem && StylingItem.bodyColor,
    fontFamily: StylingItem && StylingItem.font,
    color: StylingItem && StylingItem.fontColor,
  };

  const handleBuyTermAndCondition = (e) => {
    const isChecked = e.target.checked;
    setDefaultChecked(isChecked);
    // Display the terms and conditions modal only when the checkbox is being changed from unchecked to checked
    isChecked && dispatch(showBuyTermAndCondition());
  };
  const handleAllBuyPermitList = () => {
    dispatch(showAllBuyPermitList());
  };

  useEffect(() => {
    if (profileUpdateData) {
      profileUpdateData.vehicles = profileUpdateData.vehicles.filter(item => !item.inactive)
      setvehicleList(profileUpdateData);
    }
    validEndDate();
  }, []);
  // <span>You are only allowed to order {allowedNoOfVehcile} permit</span>

  const handleSelectPermit = (permitId) => {
    var allowedpmt =
      Array.isArray(getPaymentMethodState) &&
      getPaymentMethodState?.filter((itm) => {
        if (itm?.ruleType === "MAX_NUMBER_PERMIT_SALES") {
          return itm;
        }
      });

    if (
      PerchasedPermitList &&
      PerchasedPermitList?.length + selectedPerimtData?.length >= allowedpmt[0]?.ruleValues[0]
    ) {
      // var message =
      //   "You are only allowed select " +
      //   allowedpmt[0]?.ruleValues[0] +
      //   " vehicle for this permit";
      // setmsg(message);

      var message = "You are only allowed to order " +
        allowedpmt[0]?.ruleValues[0] +
        " permit";
      var messages = "You are only allowed to order " +
        allowedpmt[0]?.ruleValues[0] +
        " permits";

      const permitLimit = allowedpmt[0]?.ruleValues[0] < 2 ? message : messages;
      setmsg(permitLimit);
      setIsOpenAlertModal(true);
    } else {
      let dtt =
        selectedPerimtData &&
        selectedPerimtData.find((e) => e?.permit?.id === permitId);

      if (dtt) {
        // var message = "You have already added this Permit";
        // setmsg(message);
        // setIsOpenAlertModal(true);
        setSelectedPermit(
          permitList && permitList.find((e) => e?.id === permitId)
        );
        setD(permitList && permitList.find((e) => e?.id === permitId))
      } else {
        setSelectedPermit(
          permitList && permitList.find((e) => e?.id === permitId)
        );
        setD(permitList && permitList.find((e) => e?.id === permitId))
      }
      // setSelectedPermit(permitList && permitList.find((e) => e.id === permitId));
    }
  };

  //######################## Physical Permit start ################################


  const handleSelectPermit2 = (permitId) => {
    var allowedpmt =
      Array.isArray(getPaymentMethodState) &&
      getPaymentMethodState?.filter((itm) => {
        if (itm?.ruleType === "MAX_NUMBER_PERMIT_SALES") {
          return itm;
        }
      });

    if (
      PerchasedPermitList &&
      PerchasedPermitList?.length + selectedPerimtData?.length >= allowedpmt[0]?.ruleValues[0]
      // PerchasedPermitList?.length  >= allowedpmt[0]?.ruleValues[0]
    ) {
      // var message =
      //   "You are only allowed select" +
      //   allowedpmt[0]?.ruleValues[0] +
      //   " vehicle for this permit";
      var message =
        "You are only allowed to order " +
        (allowedpmt[0]?.ruleValues[0]) +
        " permit";
      var messages =
        "You are only allowed to order " +
        (allowedpmt[0]?.ruleValues[0]) +
        " permits";
      const permitMessage = allowedpmt[0]?.ruleValues[0] < 2 ? message : messages
      setmsg(permitMessage);
      setIsOpenAlertModal(true);
    } else {
      let dtt =
        selectedPerimtData &&
        selectedPerimtData.find((e) => e?.permit?.id === permitId);
      if (dtt) {
        // var message = "You have already added this Permit";
        // setmsg(message);
        // setIsOpenAlertModal(true);
        setSelectedPermit(
          Array.isArray(PhysicalPermit) &&
          PhysicalPermit.find((e) => e.id === permitId)
        );
        setD(Array.isArray(PhysicalPermit) &&
          PhysicalPermit.find((e) => e.id === permitId))
      } else {
        setSelectedPermit(
          Array.isArray(PhysicalPermit) &&
          PhysicalPermit.find((e) => e.id === permitId)
        );

        setD(Array.isArray(PhysicalPermit) &&
          PhysicalPermit.find((e) => e.id === permitId))
      }
    }
  };

  useEffect(() => {
    handleSelectPermit2();
    handleSelectPermit();
  }, [dispatch]);

  //######################## Physical Permit End ##################################

  const validation = () => {
    let isValidate = true;
    if (stepper?.current === 0) {
      if (selectedPermit && selectedPermit?.permitType && selectedPermit?.permitType?.includes("STD_PERMIT")) {
        if (selectedPermit && selectedPermit.id != null && defaultChecked) {
          isValidate = false
        }
      }
      else if (selectedPermit && selectedPermit.id != null && defaultChecked
        && virtualpermitReason?.reasonForVisitIsRequired && resionText !== "") {
        isValidate = false;
      } else if (!virtualpermitReason?.reasonForVisitIsRequired && selectedPermit
        && selectedPermit.id != null && defaultChecked) {
        isValidate = false;
      }
    }

    // if (stepper.current === 1) {
    //   if (selectedPermit === null ) {
    //     isValidate = false;
    //   } else {
    //   }
    // }

    if (stepper.current === 1) {
      if (vehicles.length > 0) {
        if (defaultsameVehicle == false) {
          isValidate = false;

        }
      }
    }
    if (stepper.current === 2) {
      isValidate = false;
    }
    return isValidate;
  };
  const [cartModal, setCartModal] = useState(false);

  const cancelShowBuyPermitsExitOrderModal = () => {
    dispatch(showBuyPermitsExitOrderModal());
  };

  const CancelBuyPermitsExitOrderModal = useCallback((type) => {
    dispatch(hideBuyPermitsExitOrderModal());
  });
  const getMessage = () => {
    // if(allowedNoOfPermit[0] && allowedNoOfPermit[0]?.ruleType === 'DENY_PERMIT_SALES'){
    //   return 'No Permits Available for Purchase'
    // }else{
    if (PhysicalPermit.length < 1) {
      if (VirtualPermit.length < 1) {
        return 'No Permits Available for Purchase'
      } else {
        return 'Permit(s) available for purchase'
      }
    } else {
      return 'Permit(s) available for purchase'
    }
    // }

  }
  const ConfirmBuyPermitsExitOrderModal = useCallback((type) => {
    history.push(RouteService.buyPermits);
    // history.push(location);
    dispatch(hideBuyPermitsExitOrderModal());
  });

  useEffect(() => {
    dispatch(getDashboardHtmlWithSession({ customerName }));
    if (user?.user?.userGroup) {
      dispatch(getCheckboxAgreementTextEditorDataAction(user?.user?.userGroup));
      dispatch(getPaymentPageEditorDataAction(user?.user?.userGroup));
      dispatch(getOrderCompletePageEditorDataAction(user?.user?.userGroup));
      dispatch(getReviewAndOrderEditorDataAction(user?.user?.userGroup));
    }
  }, [user]);

  const [showPermitCount, setShowPermitCount] = useState(3);

  const handlePermitClick = (ele) => {
    setPermitType("EFP")
    setPermitId(ele)
  }



  ////##############################Physical Permit start ######################
  const getPermitList2 = () => {
    if (!Array.isArray(PhysicalpermitsForGrid)) return null;

    return PhysicalpermitsForGrid.map((item, index) => (
      <React.Fragment key={`permit-${item.id}-${index}`}>
        <div className="wrap">
          <ListItem
              className={`${classes.vehicleRow} ${selectedPermit?.id === item?.id ? classes.active : ""}`}
              spacing
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Tab") {
                  // event.preventDefault();
                  // handleSelectPermit2(item.id);
                }
              }}
              onClick={() => handleSelectPermit2(item.id)}
          >
            <ListItemText className="step-form">
              <div className="d-flex contentwrapper">
                <PermitContent permit={item} tabIndex={0} />

                <div className="text-left">
                  <p className={classes.headinText}>
                    {item?.name} &nbsp; &nbsp;
                  </p>

                  <p>
                    {`Valid from ${moment(item?.validStartDate).format("MM/DD/YYYY")} to ${moment(item?.validEndDate).format("MM/DD/YYYY")}`}
                  </p>
                  <p>${item?.price?.toFixed(2)}</p>
                  <p>{item?.allowedNoVehicles} Vehicle limit</p>
                </div>
              </div>
            </ListItemText>
          </ListItem>
        </div>

        <Divider />
      </React.Fragment>
    ));
  };

  ////##############################Physcial permit end ########################

  ////############################## Virtual Permit Start ####################//////
  const getPermitList = () => {
    let filterPermit = permitsForGrid?.filter((item) => item?.id == permitId?.id)

    return (
      filterPermit && filterPermit?.map((item, index) => (
        <>
          <ListItem
            key={index}
            className={`${classes.activeVehicleRow} ${classes.vehicleRow}`}
            spacing
            tabIndex="0"
            onKeyDown={(event) => {
              if (event.key === "Tab") {
                // event.preventDefault();
                handleSelectPermit(item?.id);
              }
            }}
            onClick={() => {
              handleSelectPermit(item.id);
            }}
            // style={{marginTop:10,marginBottom:10}}
            className={
              selectedPermit && selectedPermit?.id === item?.id
                ? classes.active
                : ""
            }
          >
            <ListItemText className="step-form">
              <>
                <div className="d-flex contentwrapper">
                  <PermitContent permit={item} />

                  <div className="text-left">
                    <p className={classes.headinText}>
                      {item?.name} &nbsp; &nbsp;
                      {/* <b>{item?.permitType}</b> */}
                    </p>

                    <p>${item?.price?.toFixed(2)}</p>
                    <p>{item?.allowedNoVehicles} Vehicle limit</p>
                  </div>
                </div>
              </>
            </ListItemText>
          </ListItem>
          <Divider />
        </>
      ))
    )
  }

  ////############################## Virtual Permit End ######################//////

  ///////////////////////////////get all Date between two Date//////////////////////////////////////////////
  let getDaysBetweenDates = function (startDate, endDate) {
    let now = startDate.clone(),
      dates = [];

    while (now.isSameOrBefore(endDate)) {
      dates.push(now.format("MM/DD/YYYY"));
      now.add(1, "days");
    }
    return dates;
  };

  // var startDate = moment("2021-01-02");
  // var endDate = moment("2021-01-12");

  // var dateList = getDaysBetweenDates(startDate, endDate);

  ///////////////////////////////End get all Date between two Date//////////////////////////////////////////////

  const handleDateChange = (e) => {

    // setSelectedDate([e.target.value]);
    // setSelectedDate(oldArray => [...oldArray, e.target.value]);
    setTestDate(e.target.value)
    // localStorage.setItem("handleselectDate", e.target.value)
    const filteredPermit = allPermit?.filter((item, i) => {
      if (filteredPerchasedList?.indexOf(item?.id) == -1) {
        return item;
      }
    });

    setPermit([
      ...filteredPermit.filter((objItem) => {
        //e.persisit();
        if (objItem?.permitType === "EFP") {
          let dateList = getDaysBetweenDates(
            moment(objItem?.salesStartDate || objItem?.validStartDate),
            moment(objItem?.salesEndDate || objItem?.validEndDate)
          );

          let selectedDateNew = moment(e.target.value)?.format("MM/DD/YYYY");
          if (dateList?.includes(selectedDateNew)) {
            return objItem;
          } else {
            return null;
          }
        } else {
          if (
            objItem?.validStartDate == e.target.value &&
            objItem?.permitType === permitType
          ) {
            return objItem;
          } else {
            return null;
          }
        }
      }),
    ]);
  };


  const handleResion = (e) => {
    setResionText(e.target.value)
  }

  useEffect(() => {
    const filteredPermit = allPermit?.filter((item, i) => {
      if (filteredPerchasedList?.indexOf(item?.id) == -1) {
        return item;
      }
    });

    setPhysicalPermit([
      ...filteredPermit.filter((objItem) => {
        if (objItem?.permitType === "STD_PERMIT") {
          return objItem;
        } else {
          return null;
        }
      }),
    ]);

    //Virtual Permit filter

    setVirtualPermit([
      ...filteredPermit.filter((objItem) => {
        if (objItem?.permitType === "EFP") {
          let x = { ...objItem, test: "12" }
          return objItem;
        } else {
          return null;
        }
      }),
    ]);

  }, [allPermit, orderList]);

  useEffect(() => {
    const filteredPermit = allPermit?.filter((item, i) => {
      if (filteredPerchasedList?.indexOf(item?.id) == -1) {
        return item;
      }
    });
    // setPermit([
    //   ...filteredPermit.filter((objItem) => {
    //     if (
    //       objItem?.validStartDate == selectedDate &&
    //       objItem?.permitType === permitType
    //     ) {
    //       return objItem;
    //     } else {
    //       return null;
    //     }
    //   }),
    // ]);

    setPermit([
      ...filteredPermit.filter((objItem) => {
        if (objItem?.permitType === "EFP") {
          let dateList = getDaysBetweenDates(
            moment(objItem?.salesStartDate || objItem?.validStartDate),
            moment(objItem?.salesEndDate || objItem?.validEndDate)
          );
          let selectedDateNew = moment(selectedDate)?.format("MM/DD/YYYY");
          if (dateList?.includes(selectedDateNew)) {
            return objItem;
          } else {
            return null;
          }
        } else {
          if (
            objItem?.validStartDate == selectedDate &&
            objItem?.permitType === permitType
          ) {
            return objItem;
          } else {
            return null;
          }
        }
      }),
    ]);
  }, [selectedDate]);

  useEffect(() => {
    setPermit([]);
    // setSelectedDate("");
  }, [permitType, PhysicalPermit]);

  // let virtualPmt = allPermit.find((ele) => {
  //   if (ele?.permitType == "EFP") return ele;
  // });

  let virtualPmt = VirtualPermit.find((ele) => {
    if (ele?.permitType == "EFP") return ele;
  });

  // let virtualPmt = VirtualPermit.map((ele) => {
  //   if (ele?.permitType == "EFP" ) return ele;
  // });


  let dailyPmt = allPermit.find((ele) => {
    if (ele?.permitType == "DAILY") return ele;
  });

  return (
    <div style={stylingVal && stylingVal} className="permit-page-wrapper permit_mrb">
      {/* <Container maxWidth={"xl"}> */}
      <div className="header-wrapper">
        <div className="d-flex align-items-center justify-content-between">
          <div className="auth-heading makeStyles-tableheader-179" style={{ color: "#3f51b5" }}>
            {/* <Text
              color={props.StylingItem.bodyColor}
              sx
              variant={"h6"}
              className={classes.backgroundtheme}cls
              
            >
              <h1 style={{ fontSize: '20px', fontWeight: '600' }}>New Permit Order</h1>
            </Text> */}
            <h1 className="m-0" tabIndex='0' title="New permit order">New permit order</h1>
          </div>
          <div>
            {/* <IconButton>
              <ShoppingCart
                className={classes.backgroundtheme}
                onClick={(e) => handletoggleAddPermitPage("view")}
              // onClick={handleCartShowBuyPermitsExitOrderModal}
              />
            </IconButton> */}
            {/* <IconButton>
              <Badge color="primary" badgeContent={selectedPerimtData?.length || 0}>
                <ShoppingCart
                  className={classes.backgroundtheme}
                  onClick={(e) => handletoggleAddPermitPage("view")}
                />
              </Badge>
            </IconButton> */}
            <IconButton tabIndex="0" title="ShoppingCart" onClick={(e) => handletoggleAddPermitPage("view")}>
              <Badge color="primary" badgeContent={selectedPerimtData?.length || 0}>
                <ShoppingCart className={classes.backgroundtheme} />
              </Badge>
            </IconButton>
            <IconButton title="Cancel" tabIndex='0'>
              <CancelRounded
              
                className={classes.backgroundtheme}
                // onClick={(e) => handletoggleAddPermitPage(null)}
                onClick={cancelShowBuyPermitsExitOrderModal}
              />
            </IconButton>
          </div>
        </div>
        <Divider />
      </div>

      <Grid container spacing={3} style={{ marginTop: 0 }}>
        <Grid item xxl={8} xl={8} lg={8} md={12} sm={12} xs={12}>
          <Stepper activeStep={stepper.current} orientation="vertical">
            {/* ##################-----physical Permit start ----#####################*/}
            {/* {ruleValues.orderList = 0 ? } */}
            <Step className="iText" align="left" title="Select Permit">
              <List>
                {/* {allPermit.length <= 0 ? "No Permits Available for Purchase" : "Permit(s) available for purchase"} */}
                {getMessage()}

                {getPermitList2()}
                <div>

                  {/* {PhysicalPermit?.length <= 0
                    ? "Physical Permit Not Found"
                    : ""} */}
                </div>
              </List>
              {/* ###################---physical Permit end----#############33 */}
              <div
                style={{
                  marginBottom: "20px",
                  marginLeft: "5px",
                  overflowX: "auto",
                  display:
                    selectedPermit?.permitType == "STD_PERMIT"
                      ? "none"
                      : "flex",
                }}
                className={
                  selectedPermit?.permitType == "STD_PERMIT"
                    ? "widthFlex"
                    : "noFlax"
                }
              >
                {dailyPmt?.name == undefined ? (
                  ""
                ) : (
                  <span
                    style={
                      permitType === "DAILY"
                        ? { backgroundColor: "#D3D3D3" }
                        : { backgroundColor: "" }
                    }
                    onClick={(e) => setPermitType("DAILY")}
                  >
                    <div className=" text-center boxOuter2">
                      <div className="colorBox">
                        <div>
                          <p className="contentText fw-900">{dailyPmt?.name}</p>
                        </div>
                      </div>
                    </div>
                  </span>
                )}

                {/* virtual permit show */}
                {/* {allowedNoOfPermit[0] && allowedNoOfPermit[0]?.ruleType === 'DENY_PERMIT_SALES' ? '' : */}
                {VirtualPermit && VirtualPermit?.map((elee) => elee?.name == undefined ? ("") :

                  <span
                    tabIndex="0"
                    onKeyDown={(event) => {
                      if (event.key === "Tab") {
                        handlePermitClick(elee);
                      }
                    }}
                    onClick={(e) => handlePermitClick(elee)}

                    style={
                      elee.permitType === "EFP"
                        ? { backgroundColor: "#D3D3D3" }
                        : { backgroundColor: "" }
                    }
                  >
                    <div className=" text-center boxOuter2">
                      <div className="colorBox">
                        <div style={{ width: "180px" }} className="permitN">
                          <p
                            className="contentText fw-900"
                            style={{ paddingBottom: "20px" }}
                          >
                            {elee?.name}<br />
                            {/* {elee.validStartDate} {""} {elee.validEndDate} */}
                            {`Valid from ${moment(elee?.validStartDate)?.format(
                              "MM/DD/YYYY"
                            )} to ${moment(elee?.validEndDate)?.format("MM/DD/YYYY")}`}
                          </p>
                        </div>
                      </div>
                    </div>
                  </span>
                )
                }

              </div>
              {virtualPmt?.name == undefined && dailyPmt?.name == undefined ? (
                ""
              ) : (
                <>

                  <div
                    className="formGroup dateFlex"
                    style={{
                      display:
                        selectedPermit?.permitType == "STD_PERMIT" ||
                          permitType == ""
                          ? "none"
                          : "flex",
                    }}
                  >
                    <lable tabIndex="0">Select Date</lable>
                    <input
                      type="date"
                      id="selectedDate"
                      name="selectedDate"
                      value={testDate}
                      onChange={handleDateChange}
                      pattern="\d{4}-\d{2}-\d{2}"
                      min={new Date().toISOString().split("T")[0]}
                    />
                    <br />
                    {virtualpermitReason?.reasonForVisitIsEnabled ?
                      <div className="formGroup">
                        <label className="margin-bottomset" tabIndex='0'>
                          Reason for visit :{" "}
                        </label>
                        <textarea
                          id="reasonForVisit"
                          name="reasonForVisit"
                          value={resionText}
                          // placeholder="First Name"
                          onChange={handleResion}
                          fullWidth
                          rows={3}
                        ></textarea>
                      </div>
                      : ""}
                  </div>

                </>
              )}
              <List
                className={classes.vehicleDiv}
                style={{
                  position: "relative",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    display:
                      selectedPermit?.permitType == "STD_PERMIT"
                        ? "none"
                        : "flex",
                  }}
                >
                  <div tabIndex='0'
                    style={{ display: permit?.length > 0 ? "block" : "none" }}
                  >
                    {getPermitList()}
                  </div>
                </div>
                <div
                  style={{
                    color: "red",
                    display:
                      selectedPermit?.permitType == "STD_PERMIT"
                        ? "none"
                        : "flex",
                  }}
                >
                  {permitType == "DAILY" && permit?.length <= 0
                    ? selectedDate != ""
                      ? "Daily Permit Not Found"
                      : ""
                    : ""}
                  {permitType == "EFP" && permit?.length <= 0
                    ? selectedDate != ""
                      ? "Virtual Permit Not Found"
                      : ""
                    : ""}
                </div>
              </List>
              {/* {allowedNoOfPermit[0] && allowedNoOfPermit[0]?.ruleType === 'DENY_PERMIT_SALES' ? '' : */}
              {allPermit?.length > 0 ? (
                <div className={classes.dflexterm}>
                  <Checkbox
                    checked={defaultChecked}
                    color="primary"
                    onClick={handleBuyTermAndCondition}
                  />
                  <p className={classes.handleNextterms}>
                    <span>
                      <Link
                        className={classes.handleNextterms}
                        style={{ padding: 10 }}
                      >
                        Parking rules and regulations
                      </Link>
                    </span>
                  </p>
                </div>
              ) : (
                ""
              )
              }
            </Step>
            <Step title="Choose vehicle">
              <div className="centerBox1">
                <div className="box-select">
                  <Typography variant={"p"} tabIndex='0'>
                    Select up to {selectedPermit?.allowedNoVehicles || d?.allowedNoVehicles} Vehicles
                  </Typography>
                  <Box className="secondContainerChild"> 
                    <h3 className={classes.availablevehiclesHeading}>
                      <b tabIndex='0'> Available Vehicles</b>
                    </h3>
                    <Divider />
                    <List>
                      {vehicleList?.vehicles &&
                        vehicleList?.vehicles?.map((item, index) => {
                          if (item.inactive === false) {
                            return (
                              <>
                                <ListItem
                                 tabIndex='0'
                                  key={index}
                                  className={`${classes.activeVehicleRow} ${classes.vehicleRow
                                    } ${vehicles &&
                                      vehicles.findIndex(
                                        (e) =>
                                          e.licensePlate.number ===
                                          item.licensePlate.number
                                      ) !== -1
                                      ? classes.active
                                      : ""
                                    }`}
                                  spacing
                                >
                                  <ListItemSecondaryAction
                                    className={classes.checkboxcolor}
                                  >
                                    <Checkbox
                                      style={{ top: -17 }}
                                      defaultChecked={
                                        vehicles &&
                                          vehicles.findIndex(
                                            (e) =>
                                              e.licensePlate.number ===
                                              item.licensePlate.number
                                          ) !== -1
                                          ? true
                                          : false
                                      }
                                      onClick={(e) => {
                                        handleSelectvehicle(
                                          e,
                                          item?.licensePlate?.number,
                                          item
                                        );
                                      }}
                                      color="primary"
                                    />
                                  </ListItemSecondaryAction>
                                  <ListItemText>
                                    <p
                                      className={classes.availablevehiclescolor}
                                    >
                                      <b>
                                        {`${item?.year || ""} ${item?.color || ""} ${item?.make?.name || ""} ${item?.model || ""} `}
                                      </b>{" "}
                                    </p>

                                    <p>
                                      {item.licensePlate.state.code}{""} - {""} {item?.licensePlate?.number} VIN :{" "}
                                      {item?.vin || "N/A"}
                                    </p>
                                  </ListItemText>
                                </ListItem>
                                <Divider />
                              </>
                            );
                          }
                        })}
                    </List>
                  </Box>
                </div>
              </div>
            </Step>
            <Step
              align="left"
              title="Review and Add"
              style={{ paddingLeft: 0 }}
            >
              <p>
                <Text style={{ marginBottom: 10 }} tabIndex='0'>
                  Please confirm your entries below, if everything looks good
                  ,select <b>"Add"</b>
                </Text>
              </p>
              <Grid container spacing={3}>
                <Grid
                  item
                  xxl={7}
                  xl={7}
                  lg={7}
                  md={6}
                  sm={12}
                  xs={12}
                  className="w1000"
                >
                  <Card
                    className={classes.thirdStepFirstDiv}
                    style={{ marginRight: 0 }}
                  >
                    <CardHeader
                    tabIndex='0'
                      className={classes.vehicleCardHeader}
                      action={
                        <>
                        <IconButton tabindex='0'
                            title='Pencil Button'>
                          <EditRounded
                            style={{ color: "white", marginTop: 8 }}
                            onClick={(e) => handleJump(0)}
                          />
                          </IconButton>
                        </>
                      }
                      title="Permit"
                    ></CardHeader>
                    <>
                      <div
                        className="d-flex contentwrapper"
                        style={{ padding: 10 }}
                      >
                        <PermitContent permit={d} />
                        <div className="text-left">
                          <p className={classes.headinText}>
                            {selectedPermit?.name || d?.name} &nbsp; &nbsp;{" "}
                            {/* <b>{selectedPermit?.permitType}</b> */}
                          </p>

                          <p>
                            Good from{" "}
                            {moment(testDate ? testDate : d?.validStartDate
                              // selectedPermit?.validStartDate

                            )?.format(
                              "MM/DD/YYYY"
                            )}{" "}
                            to{" "} {validEndDate(d?.validEndDate, d?.validDays)}
                            {/* {
                            moment(
                              selectedPermit?.validEndDate
                              )
                              ?.format(
                              "MM/DD/YYYY"
                            )}  */}
                          </p>
                          <tr>
                            <th>Price : </th>
                            <th>
                              <p>${d?.price?.toFixed(2)}</p>
                            </th>
                          </tr>
                          <tr>
                            <th>Fee : </th>
                            <th>
                              <p>${d?.fee?.toFixed(2)}</p>
                            </th>
                          </tr>

                          <p>
                            {d?.allowedNoVehicles} Vehicle Limit
                          </p>
                        </div>
                      </div>
                    </>
                  </Card>
                </Grid>
                <Grid
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={6}
                  sm={12}
                  xs={12}
                  className="w1000"
                  style={{ marginTop: 14 }}
                >
                  <Box
                    className={classes.thirdStepFirstDiv}
                    style={{ marginleft: 10 }}
                  >
                    <Card className="contentwrap">
                      <CardHeader
                      tabIndex='0'
                        className={classes.vehicleCardHeader}
                        action={
                          <>
                          <IconButton tabindex='0'
                            title='Pencil Button'>
                            <EditRounded
                              style={{ color: "white", marginTop: 8 }}
                              onClick={(e) => handleJump(1)}
                            />
                            </IconButton>
                          </>
                        }
                        title="Vehicles"
                      ></CardHeader>
                      <ul className={classes.vehiclesUl}>
                        {vehicles &&
                          vehicles?.map((item, index) => {
                            return (
                              <>
                                <li key={index} spacing>
                                  <div className={classes.dflex1}>
                                    <div className="min-w80">
                                      <b>Vehicles {index + 1}</b> :
                                    </div>
                                    <div className={classes.headinText}>
                                      <p>
                                        {`${item?.year} ${item?.color} ${item?.make?.name} ${item?.model} `}
                                        {/* {`${item?.year} ${item?.color} ${item?.color} ${item?.model} ${item?.make?.name}`} */}
                                      </p>

                                      <p>
                                        {item.licensePlate.state.code}{""} - {item?.licensePlate?.number} VIN :{" "}
                                        {item?.vin || "N/A"}
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <Divider />
                              </>
                            );
                          })}
                      </ul>
                    </Card>
                  </Box>
                </Grid>
              </Grid>
            </Step>
            <div className={"stepperPadding"}>
              <StepperControlFooter
                submitText="Add"
                stepper={stepper}
                onNext={handleNext}
                onCancel={cancelShowBuyPermitsExitOrderModal}
                onBack={back}
                disableNext={validation()}
                onSubmit={handleSubmit}
                disabled={
                  (PerchasedPermitList &&
                    PerchasedPermitList?.length + selectedPerimtData?.length) >=
                    noOfAllowedPermit
                    ? true
                    : false
                }
              />
            </div>
          </Stepper>
        </Grid>
        {stepper.current === 2 ? (
          ""
        ) : (
          <Grid
            item
            xxl={4}
            xl={4}
            lg={4}
            md={12}
            sm={12}
            xs={12}
            onClick={() => setSelectedPermit([])}
          >
            <Box
            tabIndex='0'
              className=""
              style={{
                background: "white",
                boxShadow: "0 .125rem .25rem rgba(0,0,0,.075)",
                display: `${addpermittext && addpermittext ? "block" : "none"}`,
              }}
            >
              {addpermittext && addpermittext.text !== '' ? (
                <div
                  className="ql-editor"
                  style={{
                    color: "black", fontFamily: `${addpermittext && addpermittext?.includes("ql-font-lucinda") ? "Lucinda Sand Unicode" : addpermittext && addpermittext?.includes("ql-font-georgia") ? "Georgia" : addpermittext && addpermittext?.includes("ql-font-comic") ? "Comic Sans MS"
                      : addpermittext && addpermittext?.includes("ql-font-courier") ? "Courier New" : addpermittext && addpermittext?.includes("ql-font-tahoma") ? 'Tahoma' : addpermittext && addpermittext?.includes("ql-font-times") ? '"Times New Roman"'
                        : addpermittext && addpermittext?.includes("ql-font-trebuchet") ? "Trebuchet MS" : addpermittext && addpermittext?.includes("ql-font-verdana") ? 'Verdana'
                          : addpermittext && addpermittext?.includes("ql-font-helvetica") ? 'Helvetica' : addpermittext && addpermittext?.includes("ql-font-monospace") ? 'Monospace'
                            : addpermittext && addpermittext?.includes("ql-font-roboto") ? 'roboto' : "Arial"}`
                  }}
                  dangerouslySetInnerHTML={{ __html: addpermittext }}
                />
              ) : (
                <></>
              )}
            </Box>
          </Grid>
        )}
      </Grid>
      
      {/* </Container> */}
      <PermitAddedModel
        vehicles={vehicles}
        selectedPermit={selectedPermit}
        open={toggleAddedModel}
        onClose={handleToggleAddedModel}
        handletoggleAddPermitPage={handletoggleAddPermitPage}
        selectedDate={testDate}
        d={d}
        setvehicles={setvehicles}
        setvehicleList={setvehicleList}
      />
      <BuyPerimtsEditOrderModal
        isOpenExitOrderModal={isOpenExitOrderModal}
        CancelBuyPermitsExitOrderModal={CancelBuyPermitsExitOrderModal}
        ConfirmBuyPermitsExitOrderModal={ConfirmBuyPermitsExitOrderModal}
      />
      <BuyTermAndCondition />
      <AllBuyPermitList
        selectedPermit={selectedPermit}
        profileUpdateData={profileUpdateData}
        permitList={permitList}
        handleSelectPermit={handleSelectPermit}
      />
      <AllowedVehicleAlertModal
        isOpenAllowedVehicleAlertModal={isOpenAllowedVehicleAlertModal}
        vehicleLimit = {d}
        onBack={back}
      />
      <SameVehicleAlertModal
        isOpenAllowedSameVehicleAlertModal={isOpenAllowedSameVehicleAlertModal}
        setIsOpenAllowedSameVehicleAlertModal={setIsOpenAllowedSameVehicleAlertModal}
        setDefaultsameVehicle={setDefaultsameVehicle}
        setvehicles={setvehicles}
      />
      <AlertModal
        isOpenAlertModal={isOpenAlertModal}
        CloseAlertModal={CloseAlertModal}
        data={msg}
      />
      <DenyPermitRuleModal
        openDenyPermit={openDenyPermit}
        setOpenDenyPermit={() => setOpenDenyPermit(false)} />
    </div>
  );
}